import { Button, Empty, Typography } from "antd";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import type { Carpool, CarpoolDirection, CarpoolRole } from "../types";
import type { CarpoolStore } from "../store";
import { CarpoolCard } from "./CarpoolCard";
import { CreateCarpoolModal } from "./CreateCarpoolModal";
import { JoinRequestModal } from "./JoinRequestModal";
import { EditCarpoolModal } from "./EditCarpoolModal";

interface Props {
  store: CarpoolStore;
  direction: CarpoolDirection;
  role: CarpoolRole;
  title: string;
  carpools: Carpool[];
}

const CREATE_BUTTON_LABEL: Record<CarpoolRole, string> = {
  driver: "Fahrt anbieten",
  rider: "Mitfahrt-Gesuch eintragen",
  train: "Zugverbindung eintragen",
};

const EMPTY_LABEL: Record<CarpoolRole, string> = {
  driver: "Noch keine Fahrten angeboten",
  rider: "Noch keine Fahrten gesucht",
  train: "Noch keine Zugverbindungen eingetragen",
};

export const CarpoolColumn = observer(({ store, direction, role, title, carpools }: Props) => {
  const [createOpen, setCreateOpen] = useState(false);
  const [joinTarget, setJoinTarget] = useState<Carpool | null>(null);
  const [editTarget, setEditTarget] = useState<Carpool | null>(null);

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <Typography.Title level={4} style={{ margin: 0 }}>{title}</Typography.Title>
        <Button type="primary" onClick={() => setCreateOpen(true)}>
          {CREATE_BUTTON_LABEL[role]}
        </Button>
      </div>

      {carpools.length === 0 ? (
        <Empty description={EMPTY_LABEL[role]} />
      ) : (
        carpools.map((carpool) => (
          <CarpoolCard
            key={carpool.objectId}
            carpool={carpool}
            isFull={store.isFull(carpool)}
            onJoin={() => setJoinTarget(carpool)}
            onEdit={() => setEditTarget(carpool)}
          />
        ))
      )}

      <CreateCarpoolModal
        store={store}
        direction={direction}
        role={role}
        open={createOpen}
        onClose={() => setCreateOpen(false)}
      />

      {joinTarget && (
        <JoinRequestModal
          store={store}
          carpool={joinTarget}
          open={!!joinTarget}
          onClose={() => setJoinTarget(null)}
        />
      )}

      {editTarget && (
        <EditCarpoolModal
          store={store}
          carpool={editTarget}
          open={!!editTarget}
          onClose={() => setEditTarget(null)}
        />
      )}
    </div>
  );
});
